/*
 * Auditoría UX v25 · Favoritos sin app (guía: auditoria/favoritos/favoritos-sin-app-temposhop.md).
 * Guarda handles de producto en localStorage (CONFIG.storageKey), como mucho 60 y el último primero; no sale del
 * navegador ni lleva identificadores (almacenamiento técnico pedido por el usuario: no depende del banner).
 * En CONFIG.dataKey guarda el precio y el stock de cada favorito al guardarlo (para avisar si baja o vuelve) y si ya se
 * vio el aviso de la primera vez.
 * Pone un corazón en las tarjetas (product-card), un botón en la ficha (body[data-fav-handle], que pone
 * layout/theme.liquid) y el contador de la cabecera ([data-fav-count], sections/header.liquid). Pinta la página de
 * favoritos ([data-favoritos], sections/favoritos.liquid) con /products/<handle>.js: precio con y sin IVA, «Añadir»
 * para los de una sola variante (el botón [data-ux-add] lo atiende ux-embudo), total, envío gratis, «Añadir todo al
 * carrito», «Pedir presupuesto» (Contacto con ?carrito=, como el carrito lateral) y «Compartir lista». Con
 * ?lista=handle1,handle2 enseña la lista que otra persona compartió, con «Guardar todos en mis favoritos».
 * Segunda tanda: «Guardar para luego» en el carrito (lateral y /cart), «Comparar» (de 2 a 5, en el comparador de Athens),
 * «Imprimir o guardar en PDF» y «Vistos recientemente» (sección nativa del tema) solo con consentimiento de preferencias.
 * El clic se escucha en captura y se detiene: en Athens la foto de la tarjeta es un enlace a la ficha.
 */
(function () {
  'use strict';

  var CONFIG = {
    storageKey: 'favoritos',
    dataKey: 'favoritos_datos',
    max: 60,
    card: 'product-card.card-product',
    cardLink: 'a.js-product-link',
    cardMedia: 'figure.card-media',
    productAnchor: '.product-block-buy_buttons',
    productTitle: 'h1.product-info-heading, h1',
    vatRate: 1.21,
    // Igual que snippets/ux-cart-extras.liquid: envío gratis desde 299 € sin contar GUIL; con 20 kg o más, con matiz
    freeFrom: 29900,
    heavyGrams: 20000,
    excludedVendor: 'GUIL',
    compareMax: 5,
    // Líneas del carrito lateral (.mini-cart-item) y de /cart (tr.cart-item): «Guardar para luego» pulsa el «Quitar» del tema
    cartLine: '.js-cart-item',
    cartRemove: 'cart-remove-button a, cart-remove-button button',
    cartActions: '.mini-cart-item-actions, .cart-item-details',
    cartName: '.mini-cart-item-heading, .cart-item-name',
    text: {
      save: 'Guardar en favoritos',
      saved: 'Guardado en favoritos',
      listaSave: 'Guardar',
      listaSaved: 'Guardado',
      savedAnnounce: 'Guardado en favoritos.',
      removedAnnounce: 'Quitado de favoritos.',
      ariaSave: 'Guardar en favoritos: ',
      ariaRemove: 'Quitar de favoritos: ',
      header: 'Favoritos',
      from: 'Desde ',
      net: ' sin IVA',
      soldOut: 'Agotado',
      tpQuote: 'Precio a consultar',
      tpQuoteAsk: 'Pedir presupuesto',
      remove: 'Quitar',
      add: 'Añadir',
      choose: 'Ver opciones',
      one: '1 producto guardado',
      many: ' productos guardados',
      sharedOne: '1 producto',
      sharedMany: ' productos',
      sharedEyebrow: 'Te han pasado esta lista',
      sharedTitle: 'Lista compartida',
      sharedText: 'Guarda estos productos en tus favoritos, añádelos al carrito o pide presupuesto.',
      sharedGone: 'Los productos de esta lista ya no están en la tienda.',
      total: 'Total',
      totalSoldOut: ' · sin contar los agotados',
      shipAll: 'Si lo pides todo, ',
      shipLeft: 'te faltan ',
      shipLeftEnd: ' para el envío gratis',
      shipDone: 'tienes envío gratis',
      shipDoneGuil: ' (salvo los productos GUIL)',
      shipHeavy: 'superas los 299 € del envío gratis',
      shipGuilOnly: 'Los productos GUIL se envían con su propia tarifa; la verás antes de pagar.',
      shipNote: 'Península y Baleares. No incluye GUIL ni artículos voluminosos.',
      shipHeavyNote: 'La lista pesa más de 20 kg: algunos artículos pueden llevar coste de envío. Lo verás antes de pagar.',
      addAll: 'Añadir todo al carrito',
      addSome: 'Añadir al carrito los ',
      addSomeEnd: ' que se pueden',
      adding: 'Añadiendo…',
      added: 'Añadido al carrito',
      addFail: 'No se ha podido añadir',
      addPartial: ' añadidos; el resto no tiene stock ahora.',
      addHint: 'Los productos con varias opciones se eligen en su ficha.',
      quote: 'Pedir presupuesto',
      quoteChoose: ' (opción por elegir)',
      share: 'Compartir lista',
      shareWhatsapp: 'Enviar por WhatsApp',
      shareCopy: 'Copiar enlace',
      shareCopied: 'Enlace copiado',
      shareSelect: 'Enlace seleccionado: cópialo',
      shareMsg: 'Mi lista de favoritos en Tempo Shop: ',
      shareTitle: 'Mis favoritos de Tempo Shop',
      saveAll: 'Guardar todos en mis favoritos',
      savedAll: 'Guardados en tus favoritos',
      mine: 'Ver mis favoritos',
      priceDrop: 'Ha bajado ',
      priceDropEnd: ' desde que lo guardaste',
      backInStock: 'Vuelve a estar disponible',
      toast: 'Guardado en favoritos',
      toastLink: 'Ver favoritos',
      close: 'Cerrar',
      later: 'Guardar para luego',
      laterAria: 'Guardar para luego en favoritos: ',
      laterToast: 'Guardado en favoritos para luego',
      compare: 'Comparar',
      compareGo: 'Comparar',
      compareOne: '1 seleccionado',
      compareMany: ' seleccionados',
      compareMin: 'Elige otro para comparar',
      compareLimit: 'Puedes comparar hasta 5 productos',
      compareClear: 'Quitar la selección',
      print: 'Imprimir o guardar en PDF',
      printShop: 'Tempo Shop',
      printCompany: 'Tempo Group Iberia, S.L. · CIF B56767304',
      printTitle: 'Lista de productos',
      printSharedTitle: 'Lista compartida',
      printDate: 'Fecha: ',
      printProduct: 'Producto',
      printPrice: 'Precio',
      printNet: 'Sin IVA',
      printRef: 'Ref. ',
      printOptions: 'Varias opciones: se elige en la ficha',
      printNote: 'Precios con IVA (21 %) a la fecha indicada; pueden cambiar sin aviso. Disponibilidad y plazo de envío en la ficha de cada producto.',
      printContact: 'Presupuestos: shop@tempogroupiberia.es · +34 621 04 64 70 · temposhop.es'
    }
  };

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var PAGE = ROOT + 'pages/favoritos';
  var SVG_NS = 'http://www.w3.org/2000/svg';
  // Corazón con el mismo trazo que los iconos del tema (24 × 24, línea de 1,5)
  var HEART = 'M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572';
  var HANDLE_RE = /^[a-z0-9][a-z0-9-]*$/;

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(CONFIG.storageKey) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && HANDLE_RE.test(h); }) : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { window.localStorage.setItem(CONFIG.storageKey, JSON.stringify(list.slice(0, CONFIG.max))); } catch (e) {}
    sync();
  }
  function toggle(h) {
    var l = read(); var i = l.indexOf(h);
    if (i === -1) l.unshift(h); else l.splice(i, 1);
    write(l);
    return i === -1;
  }
  function remove(h) {
    var l = read(); var i = l.indexOf(h);
    if (i !== -1) { l.splice(i, 1); write(l); }
    forget(h);
  }
  function handleFrom(href) {
    var m = /\/products\/([a-z0-9][a-z0-9-]*)/.exec(href || '');
    return m ? m[1] : null;
  }
  // Evento de Clarity, solo si el visitante aceptó las estadísticas y Clarity está cargado (ux-audit)
  function track(name) {
    try { if (typeof window.clarity === 'function') window.clarity('event', name); } catch (e) {}
  }

  /* Datos de cada favorito: { aviso: true si ya se enseñó el aviso de la primera vez,
     p: { handle: [precio en céntimos, 1 si había stock, fecha] } } */
  function readData() {
    try {
      var d = JSON.parse(window.localStorage.getItem(CONFIG.dataKey) || '{}');
      if (!d || typeof d !== 'object') d = {};
      if (!d.p || typeof d.p !== 'object') d.p = {};
      return d;
    } catch (e) { return { p: {} }; }
  }
  function writeData(d) {
    try { window.localStorage.setItem(CONFIG.dataKey, JSON.stringify(d)); } catch (e) {}
  }
  function snapshot(p) { return [p.price_min, p.available ? 1 : 0, Date.now()]; }
  function remember(h) {
    getProduct(h).then(function (p) {
      if (!p || p.missing || read().indexOf(h) === -1) return;
      var d = readData(); d.p[h] = snapshot(p); writeData(d);
    });
  }
  function forget(h) {
    var d = readData();
    if (d.p[h]) { delete d.p[h]; writeData(d); }
  }

  function icon(size) {
    var svg = document.createElementNS(SVG_NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', String(size || 20)); svg.setAttribute('height', String(size || 20));
    svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false');
    var p = document.createElementNS(SVG_NS, 'path'); p.setAttribute('d', HEART);
    svg.appendChild(p);
    return svg;
  }
  // kind: 'card' (tarjeta, solo icono), 'ficha' (ficha del producto) o 'lista' (lista compartida); los dos últimos con texto
  function button(h, title, kind) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fav fav--' + kind;
    b.setAttribute('data-fav', h);
    b.setAttribute('data-fav-kind', kind);
    b.setAttribute('data-fav-title', title || '');
    b.setAttribute('aria-pressed', 'false');
    b.appendChild(icon());
    if (kind !== 'card') { var t = document.createElement('span'); t.className = 'fav__text'; b.appendChild(t); }
    return b;
  }

  function decorateCards() {
    var cards = document.querySelectorAll(CONFIG.card);
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-fav]') || card.closest('[data-fav-skip]')) continue;
      var link = card.querySelector(CONFIG.cardLink);
      var h = handleFrom(link && link.getAttribute('href'));
      var media = card.querySelector(CONFIG.cardMedia);
      if (!h || !media) continue;
      media.classList.add('fav-host');
      var title = link.getAttribute('aria-label') || link.textContent.trim() || '';
      media.appendChild(button(h, title, 'card'));
    }
  }
  function decorateProduct() {
    var h = document.body && document.body.getAttribute('data-fav-handle');
    if (!h || document.querySelector('.fav--ficha')) return;
    var titleEl = document.querySelector(CONFIG.productTitle);
    var anchor = document.querySelector(CONFIG.productAnchor) || titleEl;
    if (!anchor) return;
    anchor.insertAdjacentElement('afterend', button(h, titleEl ? titleEl.textContent.trim() : '', 'ficha'));
  }
  // «Guardar para luego» en cada línea del carrito; el tema repinta el carrito y se vuelve a poner (MutationObserver)
  function decorateCartLines() {
    var rows = document.querySelectorAll(CONFIG.cartLine);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (row.querySelector('[data-fav-later]')) continue;
      var link = row.querySelector('a[href*="/products/"]');
      var h = handleFrom(link && link.getAttribute('href'));
      var box = row.querySelector(CONFIG.cartActions);
      if (!h || !box || !row.querySelector(CONFIG.cartRemove)) continue;
      var b = el('button', 'fav-later'); b.type = 'button';
      b.setAttribute('data-fav-later', h);
      b.setAttribute('aria-label', CONFIG.text.laterAria + (row.querySelector(CONFIG.cartName) || link).textContent.trim());
      b.appendChild(icon(16));
      b.appendChild(el('span', null, CONFIG.text.later));
      box.classList.add('fav-later-host');
      box.appendChild(b);
    }
  }

  // Solo escribe lo que cambia: reescribir un texto igual también es un cambio para el MutationObserver de init() y
  // volvería a llamar a run() en cada fotograma.
  function setText(node, text) { if (node && node.textContent !== text) node.textContent = text; }
  function sync() {
    var l = read(), T = CONFIG.text;
    document.querySelectorAll('[data-fav]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-fav')) !== -1;
      var kind = b.getAttribute('data-fav-kind');
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.classList.toggle('is-on', on);
      if (kind === 'ficha') setText(b.querySelector('.fav__text'), on ? T.saved : T.save);
      else if (kind === 'lista') setText(b.querySelector('.fav__text'), on ? T.listaSaved : T.listaSave);
      if (kind !== 'ficha') b.setAttribute('aria-label', (on ? T.ariaRemove : T.ariaSave) + b.getAttribute('data-fav-title'));
    });
    document.querySelectorAll('[data-fav-count]').forEach(function (c) { setText(c, l.length ? String(l.length) : ''); c.hidden = !l.length; });
    document.querySelectorAll('[data-fav-header]').forEach(function (a) { a.setAttribute('aria-label', l.length ? T.header + ' (' + l.length + ')' : T.header); });
  }

  function announce(msg) {
    var live = document.getElementById('fav-live');
    if (!live) {
      live = document.createElement('p'); live.id = 'fav-live'; live.className = 'visually-hidden';
      live.setAttribute('role', 'status'); document.body.appendChild(live);
    }
    live.textContent = msg;
  }

  // Si el banner de cookies de Shopify sigue abierto (abajo, z-index 2000000), lo que va fijo abajo se pone encima de él
  function overBanner(node) {
    var banner = document.getElementById('shopify-pc__banner'), bottom = '';
    if (banner) {
      var r = banner.getBoundingClientRect(), s = window.getComputedStyle(banner);
      var n = node.getBoundingClientRect();
      if (r.height && r.top > 0 && r.top < window.innerHeight && s.display !== 'none' && s.visibility !== 'hidden' &&
          n.right > r.left && n.left < r.right) {
        bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
      }
    }
    if (node.style.bottom !== bottom) node.style.bottom = bottom;
  }

  // Aviso de la primera vez (fuera de la página de favoritos), para que se descubra el corazón de la cabecera
  var toastTimer = null;
  function toast(text, plain) {
    var T = CONFIG.text, box = document.getElementById('fav-toast');
    if (box) box.remove();
    box = el('div', 'fav-toast'); box.id = 'fav-toast'; box.setAttribute('role', 'status');
    box.appendChild(icon(18));
    box.appendChild(el('span', 'fav-toast__text', text || T.toast));
    if (!plain) { var a = el('a', 'fav-toast__link', T.toastLink); a.href = PAGE; box.appendChild(a); }
    var x = el('button', 'fav-toast__close'); x.type = 'button'; x.setAttribute('aria-label', T.close); x.innerHTML = '&times;';
    x.addEventListener('click', function () { box.remove(); });
    box.appendChild(x);
    document.body.appendChild(box);
    overBanner(box);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { if (box.parentNode) box.remove(); }, 6000);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-fav]') : null;
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-fav');
    var on = toggle(h);
    b.classList.remove('is-pulse'); void b.offsetWidth; if (on) b.classList.add('is-pulse');
    announce(on ? CONFIG.text.savedAnnounce : CONFIG.text.removedAnnounce);
    if (on) {
      remember(h);
      var kind = b.getAttribute('data-fav-kind');
      track(kind === 'ficha' ? 'favorito_ficha' : kind === 'lista' ? 'favorito_lista' : 'favorito_tarjeta');
      var d = readData();
      if (!d.aviso && !document.querySelector('[data-favoritos]')) { d.aviso = true; writeData(d); toast(); }
    } else {
      forget(h);
    }
    if (b.getAttribute('data-fav-kind') !== 'lista') renderPage();
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-fav-later]') : null;
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-fav-later'), l = read();
    if (l.indexOf(h) === -1) { l.unshift(h); write(l); remember(h); }
    var d = readData(); if (!d.aviso) { d.aviso = true; writeData(d); }
    track('favoritos_guardar_luego');
    toast(CONFIG.text.laterToast);
    var row = b.closest(CONFIG.cartLine), rm = row && row.querySelector(CONFIG.cartRemove);
    if (rm) rm.click();
  });

  /* Página de favoritos */
  function money(cents, fmt) {
    var f = (Number(cents || 0) / 100).toFixed(2).split('.');
    var dots = f[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var commas = f[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (fmt || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dots + ',' + f[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dots)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, commas)
      .replace(/\{\{\s*amount\s*\}\}/, commas + '.' + f[1]);
  }
  // Como snippets/price.liquid (precio | times: 100 | divided_by: 121): redondeo hacia abajo, para que coincida al céntimo
  function net(cents) { return Math.floor(cents * 100 / Math.round(CONFIG.vatRate * 100)); }
  function img(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  var cache = {};
  function getProduct(h) {
    if (!cache[h]) {
      cache[h] = fetch(ROOT + 'products/' + h + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (r.status === 404) return { missing: true }; if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function () { delete cache[h]; return null; });
    }
    return cache[h];
  }
  function el(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  // Presupuesto: productos con la etiqueta a-consultar (ver snippets/leeme-presupuesto.liquid)
  function aConsultar(p) { return (p.tags || []).indexOf('a-consultar') !== -1; }

  function single(p) { var v = p.variants || []; return p.available && v.length === 1 && v[0].available ? v[0] : null; }

  function item(p, fmt, shared, saved) {
    var T = CONFIG.text;
    var li = el('li', 'favs__item');
    var a = el('a', 'favs__link'); a.href = ROOT + 'products/' + p.handle;
    var media = el('span', 'favs__media');
    if (p.featured_image) {
      var im = document.createElement('img');
      im.src = img(p.featured_image, 600);
      im.srcset = img(p.featured_image, 360) + ' 360w, ' + img(p.featured_image, 600) + ' 600w, ' + img(p.featured_image, 900) + ' 900w';
      im.sizes = '(min-width: 990px) 22vw, (min-width: 600px) 30vw, 46vw';
      im.alt = ''; im.loading = 'lazy'; im.width = 600; im.height = 600;
      media.appendChild(im);
    }
    a.appendChild(media);
    if (p.vendor) a.appendChild(el('span', 'favs__brand', p.vendor));
    a.appendChild(el('span', 'favs__name', p.title));
    var cents = p.price_varies ? p.price_min : p.price;
    var quote = aConsultar(p);
    if (quote) a.appendChild(el('span', 'favs__price tp-precio-consulta', T.tpQuote));
    else {
      a.appendChild(el('span', 'favs__price', (p.price_varies ? T.from : '') + money(cents, fmt)));
      a.appendChild(el('span', 'favs__net', money(net(cents), fmt) + T.net));
    }
    if (quote) { /* presupuesto: sin precio ni stock */ }
    else if (!p.available) a.appendChild(el('span', 'favs__soldout', T.soldOut));
    else if (saved && p.price_min < saved[0]) a.appendChild(el('span', 'favs__badge', T.priceDrop + money(saved[0] - p.price_min, fmt) + T.priceDropEnd));
    else if (saved && !saved[1]) a.appendChild(el('span', 'favs__badge favs__badge--back', T.backInStock));
    li.appendChild(a);
    var actions = el('div', 'favs__actions');
    var v = single(p);
    if (quote) {
      var ask = el('a', 'ux-acc-add ux-acc-add--choose favs__add', T.tpQuoteAsk);
      ask.href = ROOT + 'products/' + p.handle;
      actions.appendChild(ask);
    } else if (v) {
      var add = el('button', 'ux-acc-add favs__add'); add.type = 'button';
      add.setAttribute('data-ux-add', String(v.id));
      add.setAttribute('aria-label', T.add + ': ' + p.title);
      add.appendChild(el('span', 'ux-acc-add-label', T.add));
      actions.appendChild(add);
    } else if (p.available) {
      var choose = el('a', 'ux-acc-add ux-acc-add--choose favs__add', T.choose);
      choose.href = ROOT + 'products/' + p.handle;
      actions.appendChild(choose);
    }
    if (shared) {
      actions.appendChild(button(p.handle, p.title, 'lista'));
    } else {
      var rm = el('button', 'favs__remove', T.remove); rm.type = 'button';
      rm.setAttribute('aria-label', T.ariaRemove + p.title);
      rm.addEventListener('click', function () { remove(p.handle); announce(T.removedAnnounce); renderPage(); });
      actions.appendChild(rm);
    }
    var cmp = el('label', 'favs__compare');
    var cb = el('input'); cb.type = 'checkbox'; cb.value = p.handle; cb.setAttribute('data-favs-compare', '');
    cb.checked = compareSel.indexOf(p.handle) !== -1;
    cmp.appendChild(cb); cmp.appendChild(el('span', null, T.compare));
    actions.appendChild(cmp);
    li.appendChild(actions);
    return li;
  }

  /* Comparar: de 2 a 5 favoritos en el comparador de Athens (/products/<primero>?view=compare&handles=…) */
  var compareSel = [];
  function compareUrl() {
    return ROOT + 'products/' + compareSel[0] + '?view=compare' +
      compareSel.slice(1).map(function (h) { return '&handles=' + encodeURIComponent(h); }).join('');
  }
  function compareBar() {
    var T = CONFIG.text, bar = document.getElementById('favs-compare-bar');
    if (!document.querySelector('[data-favoritos]')) return;
    if (!bar) {
      bar = el('div', 'favs-compare-bar'); bar.id = 'favs-compare-bar';
      bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', T.compare);
      bar.appendChild(el('span', 'favs-compare-bar__count'));
      var go = el('a', 'button favs-compare-bar__go'); go.setAttribute('data-ux-track', 'favoritos_comparar');
      bar.appendChild(go);
      var x = el('button', 'favs-compare-bar__clear'); x.type = 'button';
      x.setAttribute('aria-label', T.compareClear); x.innerHTML = '&times;';
      x.addEventListener('click', function () {
        compareSel = [];
        document.querySelectorAll('[data-favs-compare]').forEach(function (c) { c.checked = false; });
        compareBar();
      });
      bar.appendChild(x);
      document.body.appendChild(bar);
    }
    var n = compareSel.length, link = bar.querySelector('.favs-compare-bar__go');
    bar.hidden = !n;
    if (n) overBanner(bar);
    setText(bar.querySelector('.favs-compare-bar__count'), n === 1 ? T.compareOne : n + T.compareMany);
    if (n >= 2) { link.href = compareUrl(); link.removeAttribute('aria-disabled'); setText(link, T.compareGo + ' (' + n + ')'); }
    else { link.removeAttribute('href'); link.setAttribute('aria-disabled', 'true'); setText(link, T.compareMin); }
  }
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.hasAttribute || !cb.hasAttribute('data-favs-compare')) return;
    var h = cb.value, i = compareSel.indexOf(h);
    if (cb.checked && i === -1) {
      if (compareSel.length >= CONFIG.compareMax) { cb.checked = false; toast(CONFIG.text.compareLimit, true); return; }
      compareSel.push(h);
    } else if (!cb.checked && i !== -1) {
      compareSel.splice(i, 1);
    }
    compareBar();
  });

  /* Imprimir o guardar en PDF: una hoja limpia con la lista (solo #favs-print se imprime; ver favoritos.css) */
  function printList(products, fmt, shared) {
    var T = CONFIG.text, old = document.getElementById('favs-print');
    if (old) old.remove();
    var now = new Date();
    var date = ('0' + now.getDate()).slice(-2) + '/' + ('0' + (now.getMonth() + 1)).slice(-2) + '/' + now.getFullYear();
    var wrap = el('div'); wrap.id = 'favs-print';
    var head = el('div', 'favs-print__head');
    var brand = el('div');
    brand.appendChild(el('p', 'favs-print__shop', T.printShop));
    brand.appendChild(el('p', 'favs-print__company', T.printCompany));
    head.appendChild(brand);
    var meta = el('div', 'favs-print__meta');
    meta.appendChild(el('p', 'favs-print__title', shared ? T.printSharedTitle : T.printTitle));
    meta.appendChild(el('p', 'favs-print__date', T.printDate + date));
    head.appendChild(meta);
    wrap.appendChild(head);
    var table = el('table', 'favs-print__table'), thead = el('thead'), hr = el('tr');
    ['', T.printProduct, T.printPrice, T.printNet].forEach(function (txt) { hr.appendChild(el('th', null, txt)); });
    thead.appendChild(hr); table.appendChild(thead);
    var tbody = el('tbody'), sum = 0, count = 0, varies = false;
    products.forEach(function (p) {
      var tr = el('tr'), cents = p.price_varies ? p.price_min : p.price;
      var tdImg = el('td', 'favs-print__img');
      if (p.featured_image) { var im = document.createElement('img'); im.src = img(p.featured_image, 160); im.alt = ''; im.width = 64; im.height = 64; tdImg.appendChild(im); }
      tr.appendChild(tdImg);
      var tdName = el('td');
      if (p.vendor) tdName.appendChild(el('span', 'favs-print__brand', p.vendor));
      tdName.appendChild(el('span', 'favs-print__name', p.title));
      var v = (p.variants || []).length === 1 ? p.variants[0] : null;
      tdName.appendChild(el('span', 'favs-print__ref', v ? (v.sku ? T.printRef + v.sku : '') : T.printOptions));
      var quote = aConsultar(p);
      if (!p.available && !quote) tdName.appendChild(el('span', 'favs-print__soldout', T.soldOut));
      tr.appendChild(tdName);
      tr.appendChild(el('td', 'favs-print__num', quote ? T.tpQuote : (p.price_varies ? T.from : '') + money(cents, fmt)));
      tr.appendChild(el('td', 'favs-print__num', quote ? '' : money(net(cents), fmt)));
      tbody.appendChild(tr);
      if (p.available && !quote) { sum += p.price_min; count++; varies = varies || p.price_varies; }
    });
    table.appendChild(tbody);
    if (count) {
      var tfoot = el('tfoot'), fr = el('tr');
      fr.appendChild(el('td'));
      fr.appendChild(el('td', null, T.total + ' (' + (count === 1 ? T.sharedOne : count + T.sharedMany) + (count < products.length ? T.totalSoldOut : '') + ')'));
      fr.appendChild(el('td', 'favs-print__num', (varies ? T.from : '') + money(sum, fmt)));
      fr.appendChild(el('td', 'favs-print__num', money(net(sum), fmt)));
      tfoot.appendChild(fr); table.appendChild(tfoot);
    }
    wrap.appendChild(table);
    wrap.appendChild(el('p', 'favs-print__note', T.printNote));
    wrap.appendChild(el('p', 'favs-print__contact', T.printContact));
    document.body.appendChild(wrap);
    document.documentElement.classList.add('favs-printing');
    track('favoritos_imprimir');
    // Espera a las fotos (como mucho 2,5 s) para que salgan en la hoja
    var waits = [].map.call(wrap.querySelectorAll('img'), function (im) {
      return im.complete ? Promise.resolve() : new Promise(function (r) { im.onload = im.onerror = r; });
    });
    Promise.race([Promise.all(waits), new Promise(function (r) { setTimeout(r, 2500); })]).then(function () { window.print(); });
  }
  window.addEventListener('afterprint', function () {
    document.documentElement.classList.remove('favs-printing');
    var w = document.getElementById('favs-print'); if (w) w.remove();
  });

  /* Resumen: total, envío gratis, «Añadir todo al carrito», «Pedir presupuesto» y «Compartir lista» */
  function shipBar(products, fmt) {
    var T = CONFIG.text, eligible = 0, grams = 0, guil = false;
    products.forEach(function (p) {
      if (!p.available) return;
      if (p.vendor === CONFIG.excludedVendor) { guil = true; return; }
      eligible += p.price_min;
      var v = (p.variants || []).filter(function (x) { return x.available; })[0];
      grams += v && v.weight ? v.weight : 0;
    });
    var left = CONFIG.freeFrom - eligible, heavy = grams >= CONFIG.heavyGrams;
    var bar = el('div', 'ux-ship-bar ux-ship-bar--favs' + (left <= 0 ? ' is-done' : ''));
    if (!eligible) {
      if (!guil) return null;
      bar.appendChild(el('p', 'ux-ship-bar-text', T.shipGuilOnly));
      return bar;
    }
    var text = el('p', 'ux-ship-bar-text');
    text.appendChild(document.createTextNode(T.shipAll));
    if (left <= 0) {
      text.appendChild(el('strong', null, heavy ? T.shipHeavy : T.shipDone));
      if (!heavy && guil) text.appendChild(document.createTextNode(T.shipDoneGuil));
    } else {
      text.appendChild(document.createTextNode(T.shipLeft));
      text.appendChild(el('strong', null, money(left, fmt)));
      text.appendChild(document.createTextNode(T.shipLeftEnd));
    }
    bar.appendChild(text);
    var meter = el('div', 'ux-ship-bar-track'); meter.setAttribute('aria-hidden', 'true');
    var fill = el('span'); fill.style.width = Math.min(100, Math.floor(eligible * 100 / CONFIG.freeFrom)) + '%';
    meter.appendChild(fill); bar.appendChild(meter);
    bar.appendChild(el('p', 'ux-ship-bar-note', heavy ? T.shipHeavyNote : T.shipNote));
    return bar;
  }

  function sectionsToRender(mc) {
    var out = [];
    if (mc && mc.getSectionsToRender) {
      mc.getSectionsToRender().forEach(function (s) { if (s.section && out.indexOf(s.section) === -1) out.push(s.section); });
    }
    return out;
  }
  function cartAdd(items, sections) {
    var url = ((window.routes && window.routes.cart_add_url) || ROOT + 'cart/add') + '.js';
    var body = { items: items };
    if (sections && sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || r.status); return j; }); });
  }
  // Mismo final que «Añadir» de ux-embudo: repintar el carrito lateral y abrirlo
  function showCart(mc, state, opener) {
    if (mc && state && state.sections && mc.renderContents) mc.renderContents(state);
    if (mc && mc.open && !(mc.drawer && mc.drawer.isOpen)) mc.open(opener);
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'favoritos', cartData: state });
  }
  function addAll(btn, variants, hint) {
    var T = CONFIG.text;
    if (btn.classList.contains('is-loading')) return;
    var mc = window.miniCart || document.querySelector('mini-cart');
    var sections = sectionsToRender(mc), original = btn.textContent;
    btn.classList.add('is-loading'); btn.textContent = T.adding;
    function done(ok, total) {
      btn.classList.remove('is-loading');
      btn.textContent = ok ? T.added : T.addFail;
      if (ok && ok < total) hint.textContent = ok + ' de ' + total + T.addPartial;
      if (ok) track('favoritos_todo_carrito');
      setTimeout(function () { btn.textContent = original; }, 3000);
    }
    var items = variants.map(function (id) { return { id: id, quantity: 1 }; });
    cartAdd(items, sections).then(function (state) {
      showCart(mc, state, btn); done(items.length, items.length);
    }).catch(function () {
      // Si falla uno, Shopify no añade ninguno: se prueban uno a uno y luego se pide el carrito lateral ya repintado
      var ok = 0;
      items.reduce(function (chain, it) {
        return chain.then(function () { return cartAdd([it]).then(function () { ok++; }, function () {}); });
      }, Promise.resolve()).then(function () {
        if (!ok || !sections.length) { done(ok, items.length); return; }
        fetch(window.location.pathname + '?sections=' + sections.join(','))
          .then(function (r) { return r.json(); })
          .then(function (json) { showCart(mc, { sections: json }, btn); }, function () {})
          .then(function () { done(ok, items.length); });
      });
    });
  }

  function quoteHref(products) {
    var T = CONFIG.text;
    var lines = products.map(function (p) {
      var v = (p.variants || []).length === 1 ? p.variants[0] : null;
      return '1 × ' + p.title + (v ? (v.sku ? ' · SKU ' + v.sku : '') : T.quoteChoose);
    }).join('; ');
    if (lines.length > 1500) lines = lines.slice(0, 1497) + '...';
    return ROOT + 'pages/contact?carrito=' + encodeURIComponent(lines);
  }

  function shareUrl(handles) { return window.location.origin + PAGE + '?lista=' + handles.join(','); }
  function shareBlock(handles) {
    var T = CONFIG.text, url = shareUrl(handles);
    var wrap = el('div', 'favs__share-wrap');
    var btn = el('button', 'favs__share-btn', T.share); btn.type = 'button';
    btn.setAttribute('aria-expanded', 'false');
    var panel = el('div', 'favs__share'); panel.hidden = true;
    var wa = el('a', 'favs__share-link', T.shareWhatsapp);
    wa.href = 'https://wa.me/?text=' + encodeURIComponent(T.shareMsg + url);
    wa.target = '_blank'; wa.rel = 'noopener';
    wa.setAttribute('data-ux-track', 'favoritos_compartir');
    var input = el('input', 'favs__share-url'); input.type = 'text'; input.readOnly = true; input.value = url;
    input.setAttribute('aria-label', T.shareCopy);
    var copy = el('button', 'favs__share-link', T.shareCopy); copy.type = 'button';
    copy.addEventListener('click', function () {
      function selectIt() { input.focus(); input.select(); copy.textContent = T.shareSelect; }
      track('favoritos_compartir');
      try {
        navigator.clipboard.writeText(url).then(function () {
          copy.textContent = T.shareCopied; setTimeout(function () { copy.textContent = T.shareCopy; }, 2500);
        }, selectIt);
      } catch (e) { selectIt(); }
    });
    panel.appendChild(wa); panel.appendChild(copy); panel.appendChild(input);
    btn.addEventListener('click', function () {
      // En el móvil, el menú de compartir del sistema (WhatsApp, correo, copiar…); en el ordenador, el panel
      if (navigator.share && window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        navigator.share({ title: T.shareTitle, text: T.shareMsg, url: url })
          .then(function () { track('favoritos_compartir'); }, function () {});
        return;
      }
      panel.hidden = !panel.hidden;
      btn.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    });
    wrap.appendChild(btn); wrap.appendChild(panel);
    return wrap;
  }

  function summary(box, products, fmt, shared, handles) {
    var T = CONFIG.text;
    box.textContent = '';
    if (!products.length) { box.hidden = true; return; }
    var buyable = products.filter(function (p) { return p.available && !aConsultar(p); });
    var totals = el('div', 'favs__totals');
    if (buyable.length) {
      var sum = 0, varies = false;
      buyable.forEach(function (p) { sum += p.price_min; varies = varies || p.price_varies; });
      var line = el('p', 'favs__total');
      line.appendChild(el('span', 'favs__total-label', T.total + ' (' + (buyable.length === 1 ? T.sharedOne : buyable.length + T.sharedMany) + ')'));
      line.appendChild(el('strong', 'favs__total-sum', (varies ? T.from : '') + money(sum, fmt)));
      line.appendChild(el('span', 'favs__total-net', money(net(sum), fmt) + T.net + (buyable.length < products.length ? T.totalSoldOut : '')));
      totals.appendChild(line);
      var bar = shipBar(products, fmt);
      if (bar) totals.appendChild(bar);
    }
    box.appendChild(totals);

    var cta = el('div', 'favs__cta');
    var hint = el('p', 'favs__hint');
    var ids = products.filter(function (p) { return !aConsultar(p); }).map(single).filter(Boolean).map(function (v) { return v.id; });
    if (shared) {
      var all = el('button', 'button favs__saveall', T.saveAll); all.type = 'button';
      all.addEventListener('click', function () {
        var l = read();
        handles.slice().reverse().forEach(function (h) { if (l.indexOf(h) === -1) { l.unshift(h); remember(h); } });
        write(l);
        all.textContent = T.savedAll; all.disabled = true;
        track('favoritos_guardar_todos');
      });
      cta.appendChild(all);
    }
    if (ids.length > 1) {
      var addBtn = el('button', 'button' + (shared ? ' button-secondary button-outline' : '') + ' favs__addall',
        ids.length === buyable.length ? T.addAll : T.addSome + ids.length + T.addSomeEnd);
      addBtn.type = 'button';
      addBtn.addEventListener('click', function () { addAll(addBtn, ids, hint); });
      cta.appendChild(addBtn);
      if (ids.length < buyable.length) hint.textContent = T.addHint;
    }
    var quote = el('a', 'button button-secondary button-outline favs__quote', T.quote);
    quote.href = quoteHref(products);
    quote.setAttribute('data-ux-track', 'presupuesto_favoritos');
    cta.appendChild(quote);
    if (shared) {
      var mine = el('a', 'favs__mine', T.mine); mine.href = PAGE;
      cta.appendChild(mine);
    } else {
      cta.appendChild(shareBlock(handles));
    }
    var printBtn = el('button', 'favs__print-btn', T.print); printBtn.type = 'button';
    printBtn.addEventListener('click', function () { printList(products, fmt, shared); });
    cta.appendChild(printBtn);
    box.appendChild(cta);
    box.appendChild(hint);
    box.hidden = false;
  }

  function sharedList() {
    var raw = new URLSearchParams(window.location.search).get('lista');
    if (!raw) return null;
    var out = [];
    raw.split(',').forEach(function (h) { h = h.trim(); if (HANDLE_RE.test(h) && out.indexOf(h) === -1) out.push(h); });
    return out.length ? out.slice(0, CONFIG.max) : null;
  }
  function sharedHeading(root) {
    var T = CONFIG.text;
    var eyebrow = root.querySelector('.favs__eyebrow'), title = root.querySelector('.favs__title'), text = root.querySelector('.favs__text');
    if (eyebrow) setText(eyebrow, T.sharedEyebrow);
    if (title) setText(title, T.sharedTitle);
    if (text) setText(text, T.sharedText);
  }

  var token = 0, sharedTracked = false;
  function renderPage() {
    var root = document.querySelector('[data-favoritos]'); if (!root) return;
    var list = root.querySelector('[data-favs-list]'), empty = root.querySelector('[data-favs-empty]'), count = root.querySelector('[data-favs-count]');
    var box = root.querySelector('[data-favs-summary]');
    var shared = sharedList();
    var fmt = root.getAttribute('data-money-format'), handles = shared || read(), mine = ++token, T = CONFIG.text;
    if (shared) {
      sharedHeading(root);
      if (!sharedTracked) { sharedTracked = true; track('favoritos_lista_abierta'); }
    }
    if (!handles.length) {
      list.textContent = ''; empty.hidden = false; if (count) count.textContent = ''; if (box) box.hidden = true;
      root.removeAttribute('data-loading'); return;
    }
    empty.hidden = true; root.setAttribute('data-loading', '');
    Promise.all(handles.map(getProduct)).then(function (items) {
      if (mine !== token) return;
      var missing = [], shown = [], frag = document.createDocumentFragment();
      var data = shared ? null : readData(), dirty = false;
      items.forEach(function (p, i) {
        if (!p) return;
        if (p.missing) { missing.push(handles[i]); return; }
        var saved = data ? data.p[p.handle] : null;
        // Favoritos guardados antes de que existiera el aviso de precio: su referencia es lo que cuestan hoy
        if (data && !saved) { data.p[p.handle] = snapshot(p); dirty = true; }
        shown.push(p);
        frag.appendChild(item(p, fmt, !!shared, saved));
      });
      if (data) {
        Object.keys(data.p).forEach(function (h) { if (handles.indexOf(h) === -1 || missing.indexOf(h) !== -1) { delete data.p[h]; dirty = true; } });
        if (dirty) writeData(data);
        if (missing.length) write(read().filter(function (h) { return missing.indexOf(h) === -1; }));
      }
      list.textContent = ''; list.appendChild(frag);
      var n = shown.length;
      if (count) count.textContent = shared ? (n ? (n === 1 ? T.sharedOne : n + T.sharedMany) : T.sharedGone) : (n === 1 ? T.one : n + T.many);
      if (box) summary(box, shown, fmt, !!shared, shown.map(function (p) { return p.handle; }));
      empty.hidden = n > 0 || !!shared; root.removeAttribute('data-loading');
      root.classList.toggle('favs--single', n < 2);
      var shownHandles = shown.map(function (p) { return p.handle; });
      compareSel = n < 2 ? [] : compareSel.filter(function (h) { return shownHandles.indexOf(h) !== -1; });
      compareBar();
      sync();
    });
  }

  /* «Vistos recientemente»: la sección nativa de Athens lee la clave recentlyViewedProducts, que el tema guarda en cada
     ficha. Es personalización que el cliente no ha pedido, así que se enseña solo con consentimiento de preferencias (el
     CSS la oculta hasta que html lleva .ux-prefs-ok) y, sin él, se borra la lista. */
  function prefsGate() {
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || !cp.preferencesProcessingAllowed) return;
    var ok = !!cp.preferencesProcessingAllowed();
    document.documentElement.classList.toggle('ux-prefs-ok', ok);
    if (!ok) { try { window.localStorage.removeItem('recentlyViewedProducts'); } catch (e) {} }
  }

  function run() { decorateCards(); decorateProduct(); decorateCartLines(); sync(); }
  var pending = false;
  function queue() { if (pending) return; pending = true; requestAnimationFrame(function () { pending = false; run(); }); }
  function init() {
    run(); renderPage();
    document.addEventListener('visitorConsentCollected', prefsGate);
    // Al contestar el banner de cookies, la barra de comparar vuelve abajo del todo
    document.addEventListener('visitorConsentCollected', function () {
      setTimeout(function () { var bar = document.getElementById('favs-compare-bar'); if (bar && !bar.hidden) overBanner(bar); }, 400);
    });
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) { if (!error) prefsGate(); });
    }
    if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === CONFIG.storageKey) { sync(); renderPage(); } });
    window.addEventListener('pageshow', function (e) { if (e.persisted) { sync(); renderPage(); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
